// Esto no lo entiendo ni yo
import React from 'react'
import { CustomText } from 'src/components'
import { ProjectDiscountPayload } from 'src/core/models'

const ProjectDiscountVintagesColumn: React.FC<{ discount: ProjectDiscountPayload }> = ({ discount }) => {

  let label = '-'
  if (discount.vintages_data?.length > 0) {
    label = discount.vintages_data.map(v => v.year).join('-')
  }

  return (
    <div className='has-text-centered'>
      <CustomText label={label} />
    </div>
  )
}

export default ProjectDiscountVintagesColumn

